import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import EditAuthorPopup from './PublicationEditAuthorPopup';
import {
  getRoleNames,
  splitName,
  populateContributions,
  getFullName,
  getSubWorkTypeNameById,
  getWorkTypeNameById,
} from '../../utils';
const DEFAULT_MUSIC_CONTRIBUTIONS = [
  'Sound Recording',
  'Musical Composition + Sound Recording',
];

class PublicationAuthors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      editAuthor: null,
      authors: [],
    };
  }

  componentWillMount() {
    const { members, fields } = this.props;

    if (members) {
      if (fields && fields.authors && fields.authors.length === 0) {
        this.setInitialMigrateAuthors(members);
      } else {
        this.setState({ authors: fields.authors });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { fields, members } = nextProps;

    if (this.props.fields.authors !== fields.authors) {
      this.setState({ authors: fields.authors });
    }

    if (this.props.members !== members) {
      if (fields && fields.authors && fields.authors.length === 0) {
        this.setInitialMigrateAuthors(members);
      }
    }
  }

  setInitialMigrateAuthors(members) {
    const { fields } = this.props;
    let authors = fields.authors || [];
    let works = fields.works || [];
    if (
      fields &&
      authors &&
      authors.length === 0 &&
      works &&
      works.length > 0
    ) {
      this.props.assignAttribute('authors', this.migrateAuthors(members));
    }
  }

  migrateAuthors(members) {
    const { roles, fields, workTypes, subWorkTypes } = this.props;

    return members.map((member, i) => {
      const names = splitName(member.user_info.name);
      const roleNames = getRoleNames(member.role_ids, roles);

      // const workforhire = roleNames.indexOf('Contributor (Work for Hire)') !== -1;

      let contributions = populateContributions(roleNames);

      const typeName = getWorkTypeNameById(fields.type, workTypes);
      const subTypeName = getSubWorkTypeNameById(fields.subType, subWorkTypes);
      // Set default contributions
      if (typeName === 'Music') {
        // Set "Sound Recording" as default contributions if user selected "Music" or "Music + Sound Recording" from Creg type.
        contributions = [];
        if (DEFAULT_MUSIC_CONTRIBUTIONS.includes(subTypeName)) {
          contributions = ['Sound Recording'];
        }
      }

      return {
        id: i + 1,
        firstName: names.firstName,
        middleName: '',
        lastName: names.lastName,
        // organization: '',
        citizenship: '',
        domicile: '',
        anonymous: false,
        pseudonym: '',
        workforhire: -1,
        contributions,
        address: member.user_info.address,
        city: member.user_info.city,
        state: member.user_info.state,
        zip: member.user_info.postal,
        country: member.user_info.country,
      };
    });
  }

  openEditModal(e, author) {
    e.preventDefault();
    this.setState({
      openModal: true,
      editAuthor: author,
    });
  }

  openNewModal(e) {
    e.preventDefault();
    this.setState({
      openModal: true,
      editAuthor: null,
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      editAuthor: null,
    });
  }

  updateAuthor(authorProps) {
    const { fields } = this.props;
    const authors = fields.authors || [];

    if (this.state.editAuthor) {
      const index = R.findIndex(R.propEq('id', this.state.editAuthor.id))(
        authors
      );
      if (index !== -1) {
        authors[index] = { ...authorProps, id: this.state.editAuthor.id };
      }
    } else {
      const lastIndex = authors.length ? authors[authors.length - 1].id : 0;
      authors.push({ ...authorProps, id: lastIndex + 1 });
    }

    this.props.assignAttribute('authors', [...authors]);
  }

  deleteAuthor(e, author) {
    const { fields } = this.props;
    const authors = fields.authors || [];
    const authorName = getFullName(author);

    if (
      confirm(`Are you sure you want to delete the author "${authorName}"?`)
    ) {
      const index = R.findIndex(R.propEq('id', author.id))(authors);
      if (index !== -1) {
        authors.splice(index, 1);
        this.props.assignAttribute('authors', [...authors]);
      }
    }
  }

  handleNext() {
    const { fields } = this.props;
    const authors = fields.authors || [];

    this.props.hideAlert();

    if (authors.length) {
      const validates = R.filter(
        ({
          firstName,
          lastName,
          organization,
          citizenship,
          domicile,
        }) =>
          (organization ? !organization : !(firstName && lastName)) ||
          !(citizenship || domicile)
      )(authors);

      if (validates.length) {
        this.props.alert('error', 'Please check the required fields.');
      } else {
        this.props.router.push('/publication-reg/authorized-agent');
      }
    } else {
      this.props.alert('error', 'Please add an author at least.');
    }
  }

  renderAuthors() {
    const { authors } = this.state;

    return (
      authors && (
        <div className="table-container">
          <Table>
            <thead>
              <tr>
                <th>
                  <span className="text-red">*</span>First Name
                </th>
                <th>
                  <span className="text-red">*</span>Last Name
                </th>
                <th>Organization</th>
                <th>
                  <span className="text-red">*</span>Citizenship or
                  <br />
                  Domicile
                </th>
                <th>State</th>
                <th>Country</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {authors.map((author, i) => (
                <tr key={i}>
                  <td>{author.firstName}</td>
                  <td>{author.lastName}</td>
                  <td className="text-center">{author.organization}</td>
                  <td>{author.citizenship || author.domicile}</td>
                  <td>{author.state}</td>
                  <td>{author.country}</td>
                  <td>
                    <span className="actions">
                      <a onClick={(e) => this.openEditModal(e, author)}>
                        <FontAwesome name="pencil" />
                      </a>
                      <a onClick={(e) => this.deleteAuthor(e, author)}>
                        <FontAwesome name="trash" />
                      </a>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )
    );
  }

  render() {
    const { editAuthor } = this.state;

    return (
      <div className="select-work">
        <Heading text="Add Authors/Claimants" />
        <div className="content">
          <p>
            To register your website content on an ongoing basis, you must list the author/claimant by clicking on “+Add”. Typically, this will be the owner(s) of the website.
          </p>
          <div className="add-title-button text-right">
            <div className="add-view" onClick={(e) => this.openNewModal(e)}>
              <FontAwesome name="plus" /><span>Add</span>
            </div>
          </div>
          <p>
            <b>What about content you do not own?</b>
          </p>
          <p>
            Registration will extend only to the content that is 1) authored/owned by the claimant(s) you have provided and that is 2) first published on your website.  Any content that you do not own is automatically excluded from this claim.
          </p>
          {this.renderAuthors()}
          <br />
          <p>
            The information you provide will be used for your copyright
            application as is. Please be sure to verify that the information is
            accurate and complete now.
          </p>
          <br />

          <EditAuthorPopup
            open={this.state.openModal}
            author={editAuthor}
            onSave={(author) => this.updateAuthor(author)}
            onClose={() => this.closeModal()}
          />
        </div>

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
  members: state.users.members,
  roles: state.global.roles,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypesCoreg,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
  loadTeamMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationAuthors);



// WEBPACK FOOTER //
// src/components/Publication/PublicationAuthors.jsx